<template>
  <div>
    <base-header type="gradient-success" class="pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--8">
      <div class="card shadow">
        <div class="row p-3">
          <div class="col-lg-6 col-6 mb-1" v-if="is_allowed_create">
            <button :disabled="!showActionDelete" @click="showConfirmationModal = true" class="btn btn-danger">
              <i class="fa fa-trash"></i> Delete
            </button>
            <button @click="onEditRow" :disabled="!showActionEdit" class="btn btn-primary">
              <i class="fa fa-edit"></i> Edit
            </button>
            <button @click="onCreateUserTask" class="btn btn-primary">
              Create User Task
            </button>
          </div>
          <div class="col-6 pull-right">
            <div class="row">
              <label class="col-4 col-form-label form-control-label text-right">Brand</label>
              <div class="col-8">
                <model-list-select
                  :list="brandCodeOption"
                  v-model="watch_brand_code"
                  option-value="value"
                  option-text="text"
                  placeholder="select merchant item"
                ></model-list-select>
              </div>
            </div>
          </div>
        </div>
        <div v-if="message">
          <base-alert :type="message.type" :dismissible="true" @resetMessage="resetMessage">
            {{ message.message }}
          </base-alert>
        </div>
        <div v-if="deleteMessages">
          <base-alert
            :type="deleteMessages[0].type"
            :dismissible="true"
            v-for="(row, index) in deleteMessages"
            :key="index"
          >
            {{ row.message }}
          </base-alert>
        </div>
        <vue-bootstrap4-table
          :rows="rows"
          :columns="columns"
          :config="config"
          :classes="classes"
          @on-select-row="onSelectRow"
          @on-unselect-row="onSelectRow"
          @refresh-data="onRefreshData"
        >
          <template slot="is_giid_only_column" slot-scope="props">
            <label v-if="props.cell_value == 0"> False </label>
            <label v-if="props.cell_value == 1"> True </label>
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>
    <modal :show.sync="showConfirmationModal" modalClasses="modal-sm">
      <h3>Are you sure to delete these items?</h3>
      <ul>
        <li v-for="(row, index) in selectedItems" :key="index">
          {{ row.task_name }}
        </li>
      </ul>
      <template slot="footer">
        <div class="row">
          <div class="col-lg-6">
            <base-button type="link" class="ml-auto btn-block" @click="showConfirmationModal = false">No</base-button>
          </div>
          <div class="col-lg-6">
            <base-button type="primary" class="ml-auto btn-block" @click="onDeleteRow">Yes</base-button>
          </div>
        </div>
      </template>
    </modal>
    <modal :show.sync="showModalCreate" modal-classes="modal-lg">
      <h3 slot="header" class="modal-title" id="modal-title-default">
        {{ titlePopup }} User Task Config
      </h3>
      <form @submit.prevent>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <label class="form-control-label required"> Brand Code </label>
              <model-list-select
                :list="brandCodeOption"
                v-model="watch_brand_code"
                option-value="value"
                option-text="text"
                placeholder="select item"
                :isDisabled="isBrandCodeDisabled"
              ></model-list-select>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <base-input
                alternative=""
                label="Category Name"
                required
                input-classes="form-control"
                v-model="UserTaskConfigModel.category_name"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-8">
            <div class="form-group has-label">
              <base-input
                alternative=""
                required
                label="Task Name"
                input-classes="form-control"
                v-model="UserTaskConfigModel.task_name"
              />
            </div>
          </div>
          <div class="col-lg-4">
            <div class="form-group has-label">
              <base-input
                alternative=""
                required
                label="Rank"
                :min="1"
                input-classes="form-control"
                v-model="UserTaskConfigModel.rank"
                type="number"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-9">
            <div class="form-group has-label">
              <base-input
                alternative=""
                label="Task Description"
                input-classes="form-control"
                v-model="UserTaskConfigModel.task_description"
              />
            </div>
          </div>
          <div class="col-lg-3 d-flex align-items-center">
            <base-checkbox
              v-model="isReaction"
              class="custom-control-alternative"
              v-if="UserTaskConfigModel.task_type !== '4' && UserTaskConfigModel.task_type !== '6'"
            >
              Enable Reaction
            </base-checkbox>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group has-label">
              <label class="form-control-label required"> Task Type </label>
              <model-list-select
                :list="taskTypeOption"
                v-model="watch_task_type"
                option-value="value"
                option-text="text"
                placeholder="Select Task Type"
              ></model-list-select>
            </div>
          </div>
          <div class="col-lg-6">
            <label class="form-control-label required"> Task Rules </label>
            <multiselect
              v-model="watch_task_rules"
              tag-placeholder="Add this as Task Rules"
              placeholder="Search or add Task Rules"
              label="task_rule_name"
              track-by="id"
              @remove="onRemoveTaskRules"
              :options="filteredRulesOption"
              :multiple="true"
              :taggable="true"
            ></multiselect>
          </div>
        </div>
        <div class="row my-3">
          <div class="col-lg-6" v-if="isReaction">
            <label class="form-control-label"> Task Reaction </label>
            <multiselect
              v-model="watch_task_reaction"
              tag-placeholder="Add this as Task Reaction"
              placeholder="Search or add Task Reaction"
              label="reaction"
              track-by="id"
              :options="taskReactionOption"
              :multiple="true"
              :taggable="true"
            ></multiselect>
          </div>
          <div class="col-lg-6" v-if="['2','3','6'].includes(UserTaskConfigModel.task_type)">
            <label class="form-control-label"> Task Response </label>
            <multiselect
              v-model="watch_task_response"
              tag-placeholder="Add this as Task Response"
              placeholder="Search or add Task Response"
              label="statement"
              track-by="id"
              :options="filteredResponseOption"
              :multiple="true"
              :taggable="true"
            ></multiselect>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <base-input
                alternative=""
                label="Media"
                input-classes="form-control"
                v-model="UserTaskConfigModel.media_url"
              />
            </div>
          </div>
          <div class="col-lg-6">
            <div id="preview-container">
              <div class="preview">
                <div class="preview" v-if="isImage(UserTaskConfigModel.media_url)">
                  <img :src="UserTaskConfigModel.media_url" class="img img-thumbnail" />
                </div>
                <div class="preview" v-else-if="isVideo(UserTaskConfigModel.media_url)">
                  <video controls class="img img-thumbnail">
                    <source :src="UserTaskConfigModel.media_url" type="video/mp4" />
                  </video>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-6">
            <div class="form-group has-label">
              <label class="form-control-label required"> Start End Date </label>
              <date-picker
                v-model="startEndDate"
                range
                editable
                clearable
                value-type="YYYY-MM-DD"
                id="StartEndDate"
                :default-value="startEndDate"
                style="width: 100%"
              ></date-picker>
            </div>
          </div>
          <div class="col-lg-6">
            <div class="form-group has-label">
              <base-input
                alternative=""
                required
                label="Win Limit"
                input-classes="form-control"
                v-model="UserTaskConfigModel.win_limit"
                type="number"
              />
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <div class="form-group has-label">
              <base-input
                type="file"
                id="file-input"
                label="Thumbnail"
                accept="image/*"
                @change="onFileChange($event)"
              />
              <div id="preview-container">
                <div class="preview" v-if="uploadModel.image_url">
                  <img :src="uploadModel.image_url" class="img img-thumbnail" />
                </div>
                <div class="preview" v-else>
                  <img :src="UserTaskConfigModel.thumbnail" class="img img-thumbnail" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row"><div class="col-md-6"></div></div>
        <br />
      </form>
      <template slot="footer">
        <base-button type="link" class="ml-auto" @click="showModalCreate = false">Close/ Cancel</base-button>
        <button @click="onSubmit" :disabled="disableButtonSubmit" class="btn btn-primary">Submit</button>
      </template>
    </modal>
  </div>
</template>

<script>
import VueBootstrap4Table from "vue-bootstrap4-table";
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
import api_loyalty from "../api/api";
import BaseCheckbox from "../components/BaseCheckbox.vue";
import Multiselect from "vue-multiselect";
import "@/assets/vendor/multiselect/vue-multiselect.min.css";
import "vue2-datepicker/index.css";

export default {
  name: "UserTaskList",
  components: {
    VueBootstrap4Table,
    ModelListSelect,
    Multiselect,
    BaseCheckbox,
  },
  data() {
    return {
      is_allowed_create: false,
      watch_brand_code: "PHFortune",
      deleteMessages: [],
      showConfirmationModal: false,
      selectedItems: [],
      taskTypeOption: [
        { text: "Video", value: "1" },
        { text: "Trivia/Quiz", value: "2" },
        { text: "Survey", value: "3" },
        { text: "Update Profile", value: "4" },
        { text: "View Content", value: "5" },
        { text: "Feed", value: "6" },
        { text: "Gamification", value: "7" },
      ],
      startEndDate: [],
      showActionEdit: false,
      showActionDelete: false,
      isReaction: false,
      brandCodeOption: [],
      watch_task_type: "",
      taskRulesOption: [],
      watch_task_rules: [],
      filteredRulesOption: [],
      taskReactionOption: [],
      watch_task_reaction: [],
      taskResponseOption: [],
      filteredResponseOption: [],
      watch_task_response: [],
      isEdit: false,
      titlePopup: "Create",
      message: null,
      UserTaskConfigModel: {
        id: "",
        brand_code: "PHFortune",
        category_name: "",
        media_url: "",
        task_type: "",
        responses: [],
        rules: [],
        reactions: [],
        task_name: "",
        rank: 1,
        task_description: "",
        start_date: new Date().toISOString(),
        end_date: new Date().toISOString(),
        win_limit: 0,
        thumbnail: ""
      },
      uploadModel: {
        imageFile: null,
        image_url: null,
        imagePresignedUrl: '',
      },
      showModalCreate: false,
      showModalDetail: false,
      allUserTaskConfig: [],
      rows: [],
      columns: [
        { label: "ID", name: "id", slot_name: "action_button" },
        { label: "Brand", name: "brand_code", sort: true },
        { label: "Category", name: "category_name", sort: true },
        { label: "Task Type", name: "task_type_name", sort: true },
        { label: "Task Name", name: "task_name", sort: true },
        { label: "Rank", name: "rank", sort: true },
        { label: "Start Date", name: "start_date", sort: true },
        { label: "End Date", name: "end_date", sort: true },
        { label: "Win Limit", name: "win_limit", sort: true },
      ],
      config: {
        pagination: true,
        pagination_info: true,
        num_of_visibile_pagination_buttons: 7,
        per_page: 10,
        checkbox_rows: true,
        highlight_row_hover: true,
        rows_selectable: true,
        multi_column_sort: false,
        card_mode: false,
        selected_rows_info: true,
        per_page_options: [5, 10, 20, 30],
      },
      classes: {
        table: "table-striped table-bordered",
        row: {
          "my-row my-row2": true,
          "function-class": function (row) {
            return row.id == 1;
          },
        },
      },
    };
  },
  created() {
    this.is_allowed_create =
      this.$store.getters.isCheAdmin ||
      this.$store.getters.isFortuneAdmin ||
      this.$store.getters.isLoginUserAdmin;
    this.mappingRole();
    this.isBrandCodeDisabled = false;
    this.onRefreshData();
  },
  methods: {
    mappingRole() {
      let isCheAdmin = this.$store.getters.isCheAdmin;
      let isFortuneAdmin = this.$store.getters.isFortuneAdmin;
      let isCheReader = this.$store.getters.isCheReader;
      let isFortuneReader = this.$store.getters.isFortuneReader;
      let isAdministrator = this.$store.getters.isLoginUserAdmin;
      this.brandCodeOption = [];
      if (isCheAdmin || isAdministrator || isCheReader) {
        this.brandCodeOption.push({ text: "Chesterfield", value: "PHChe" });
        this.watch_brand_code = this.UserTaskConfigModel.brand_code = "PHChe";
      }
      if (isFortuneAdmin || isAdministrator || isFortuneReader) {
        this.brandCodeOption.push({ text: "Fortune", value: "PHFortune" });
        this.watch_brand_code = this.UserTaskConfigModel.brand_code = "PHFortune";
      }
    },
    onRemoveTaskRules(val) {
      this.handleCheckFilterTaskRule(val)
    },
    onSubmit() {
      if (this.startEndDate.length > 1) {
        this.UserTaskConfigModel.start_date = new Date(this.startEndDate[0]).toISOString();
        this.UserTaskConfigModel.end_date = new Date(this.startEndDate[1]).toISOString();
      }
      if (this.isEdit) {
        this.doUpdateUserTask();
      } else {
        this.doCreateUserTask();
      }
    },
    doCreateUserTask() {
      this.UserTaskConfigModel.id = "";
      this.showModalCreate = false;
      api_loyalty.CreateUserTaskConfig(this.UserTaskConfigModel)
        .then((data) => {
          if(data.isSuccess) 
          {
            if (this.uploadModel.imagePresignedUrl) {
              api_loyalty.S3PutObject(this.uploadModel.imagePresignedUrl, this.uploadModel.imageFile);
            }
            this.message = { message: data.message, type: "success" };
            this.onRefreshData();
            this.showModalCreate = false;
            this.onResetForm();
          }
        })
        .catch((e) => {
          this.message = { message: e.message, type: "danger" };
          this.onResetForm();
        });
    },
    handleCheckFilterTaskRule(val) {
      if (val.length > 0) {
        var tmpReactionObj = val.findIndex(x => x.reason === "1")
        var tmpCompleteObj = val.findIndex(x => x.reason === "2")
        var isContainReaction = tmpReactionObj > -1
        var isContainComplete = tmpCompleteObj > -1
        if (!isContainReaction && !isContainComplete) {
          this.filteredRulesOption = this.taskRulesOption
        } else if (isContainReaction && isContainComplete) {
          this.filteredRulesOption = []
        } else if (!isContainReaction) {
          this.filteredRulesOption = this.taskRulesOption.filter(f => f.reason === "1");
        } else if (!isContainComplete) {
          this.filteredRulesOption = this.taskRulesOption.filter(f => f.reason === "2");
        }
      }
    },
    doUpdateUserTask() {
      this.showModalCreate = false;
      api_loyalty.UpdateUserTaskConfig(this.UserTaskConfigModel)
        .then((data) => {
          if(data.isSuccess){
            if (this.uploadModel.imagePresignedUrl) {
              api_loyalty.S3PutObject(this.uploadModel.imagePresignedUrl, this.uploadModel.imageFile);
            }
            this.message = { message: data.message, type: "success" };
            this.onRefreshData();
            this.onResetForm();
            this.showModalCreate = false;
          }
        })
        .catch((e) => {
          this.message = { message: e.message, type: "danger" };
          this.onResetForm();
        });
    },
    getAllUserTaskConfig() {
      api_loyalty.GetAllUserTaskConfig(this.watch_brand_code).then((data) => {
        if(data.isSuccess){
          data.data.forEach(function (item) {
            switch (item.task_type) {
              case "1": item.task_type_name = "Video"; break;
              case "2": item.task_type_name = "Trivia/Quiz"; break;
              case "3": item.task_type_name = "Survey"; break;
              case "4": item.task_type_name = "Update Profile"; break;
              case "5": item.task_type_name = "View Content"; break;
              case "6": item.task_type_name = "Feed"; break;
              case "7": item.task_type_name = "Gamification"; break;
            }
          });
          this.rows = data.data;
          this.allUserTaskConfig = data.data;          
        }
      });
    },
    LoadOptions() {
      this.getUserTaskReactionOption();
      this.getUserTaskResponseOption();
      this.getUserTaskRulesOption();
    },
    getUserTaskRulesOption() {
      api_loyalty.GetAllUserTaskRulesConfig(this.UserTaskConfigModel.brand_code)
        .then((response) => {
          if(response.isSuccess){
            this.taskRulesOption = response.data;
            this.filteredRulesOption = this.taskRulesOption.filter(f => f.reason === "2");
          }
        });
    },
    getUserTaskReactionOption() {
      api_loyalty.GetAllUserTaskReaction(this.UserTaskConfigModel.brand_code)
        .then((response) => {
          if(response.isSuccess){
            this.taskReactionOption = response.data;
          }
        });
    },
    getUserTaskResponseOption() {
      api_loyalty.GetAllUserTaskResponse(this.UserTaskConfigModel.brand_code)
        .then((response) => {
          if(response.isSuccess){
            this.taskResponseOption = response.data;
            this.filteredResponseOption = this.taskResponseOption;
          }
        });
    },
    resetMessage() {
      this.message = null;
      this.deleteMessages = [];
      this.selectedItems = [];
    },
    onResetForm() {
      this.UserTaskConfigModel = {
        ...this.UserTaskConfigModel,
        id: "",
        brand_code: this.watch_brand_code,
        category_name: "",
        media_url: "",
        task_type: "",
        responses: [],
        rules: [],
        reactions: [],
        task_name: "",
        rank: 1,
        task_description: "",
        start_date: "",
        end_date: "",
        win_limit: 0,
        thumbnail: ""
      };
      this.uploadModel = { imageFile: null, image_url: null, imagePresignedUrl: '' }
      this.watch_task_type = "";
      this.watch_task_rules = [];
      this.watch_task_reaction = [];
      this.watch_task_response = [];
      this.isBrandCodeDisabled = false;
      this.isReaction = false;
      let momentNow = this.$moment(new Date().toUTCString());
      let StartDate = momentNow.format("YYYY-MM-DD");
      let EndDate = momentNow.add(1, "months").format("YYYY-MM-DD");
      let momStart = this.$moment(new Date(StartDate)).format("YYYY-MM-DD");
      let momEnd = this.$moment(new Date(EndDate)).format("YYYY-MM-DD");
      this.startEndDate = [momStart, momEnd];
      this.UserTaskConfigModel.start_date = new Date(this.startEndDate[0]).toISOString();
      this.UserTaskConfigModel.end_date = new Date(this.startEndDate[1]).toISOString();
    },
    onResetFormBrandCode() {
      this.UserTaskConfigModel = {
        ...this.UserTaskConfigModel,
        responses: [],
        rules: [],
        reactions: [],
      };
      this.watch_task_type = "";
      this.watch_task_rules = [];
      this.watch_task_reaction = [];
      this.watch_task_response = [];
      this.isReaction = false;
    },
    onCreateUserTask() {
      this.isEdit = false;
      this.showModalCreate = true;
      this.titlePopup = "Create"
      this.onResetForm();
    },
    toggleActive() {},
    async onRefreshData() {
      this.LoadOptions();
      this.getAllUserTaskConfig();
    },
    onSelectRow(payload) {
      this.showActionEdit = true;
      this.showActionDelete = true;
      this.selectedItems = payload.selected_items;
      if (payload.selected_items.length == 0) {
        this.showActionEdit = false;
        this.showActionDelete = false;
      }
      if (payload.selected_items.length > 1) {
        this.showActionEdit = false;
      }
    },
    onEditRow() {
      this.onResetForm();
      this.isEdit = true;
      this.showModalCreate = true;
      this.isBrandCodeDisabled = true;
      this.isReaction = false;
      this.titlePopup = "Update";
      this.UserTaskConfigModel = this.allUserTaskConfig.filter(
        (x) => x.id === this.selectedItems[0].id
      )[0];
      this.watch_task_type = this.UserTaskConfigModel.task_type;
      let tmpRules = [];
      this.UserTaskConfigModel.rules.forEach((element) => {
        let idx = this.taskRulesOption.findIndex((x) => x.id === element);
        if (idx > -1) tmpRules.push(this.taskRulesOption[idx]);
      });
      this.watch_task_rules = tmpRules;
      let tmpReactions = [];
      this.UserTaskConfigModel.reactions.forEach((element) => {
        let idx = this.taskReactionOption.findIndex((x) => x.id === element);
        if (idx > -1) tmpReactions.push(this.taskReactionOption[idx]);
      });
      this.watch_task_reaction = tmpReactions;
      let tmpResponses = [];
      this.UserTaskConfigModel.responses.forEach((element) => {
        let idx = this.taskResponseOption.findIndex((x) => x.id === element);
        if (idx > -1) tmpResponses.push(this.taskResponseOption[idx]);
      });
      this.watch_task_response = tmpResponses;
      if (this.UserTaskConfigModel.reactions.length > 0) {
        this.isReaction = true;
      }
      let StartDate = this.UserTaskConfigModel.start_date;
      let EndDate = this.UserTaskConfigModel.end_date;
      //add 1 days below to avoid when update, the date move back by 1 days due to convertion to utc
      let momStart = this.$moment(new Date(StartDate)).add(1, 'days').format("YYYY-MM-DD");
      let momEnd = this.$moment(new Date(EndDate)).add(1, 'days').format("YYYY-MM-DD");
      this.startEndDate = [momStart, momEnd];
    },
    onDeleteRow() {
      this.selectedItems.forEach((element) => {
        api_loyalty.DeleteUserTaskConfig(element).then((response) => {
          var popupType = response.isSuccess == false ? "danger" : "success";
          this.onRefreshData();
          let msg = {
            message: response.message + " : " + element.task_name + "'.",
            type: popupType,
          };
          this.deleteMessages.push(msg);
        }).catch((err) => {
          console.error(err);
          let msg = {
            message: "Failed to delete User Task '" + element.task_name + "'.",
            type: "danger",
          };
          this.deleteMessages.push(msg);
        });
      });
      this.showConfirmationModal = false;
    },
    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.uploadModel.imageFile = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          this.uploadModel.image_url = e.target.result;
          api_loyalty.GenerateS3PresignedUploadUrl(
            "usertask-catalog-image", file, "task_config", this.watch_brand_code
          ).then((data) => {
            try {
              if(data.isSuccess)
              {
                this.uploadModel.imagePresignedUrl = data.data.s3Object.uploadUrl;
                this.UserTaskConfigModel.thumbnail = data.data.s3Object.cdnUrl;
              }
            } catch (e) {
              console.log(e);
            }
          });
        };
        reader.readAsDataURL(file);
      }
    },
    isImage(url) {
      return url && url.match(/\.(jpeg|jpg|gif|png)$/i);
    },
    isVideo(url) {
      return url && url.match(/\.(mp4|webm|ogg)$/i);
    },
  },
  watch: {
    watch_task_type(val) {
      if (!this.isEdit) {
        this.UserTaskConfigModel.responses = [];
        this.watch_task_response = [];
      }
      this.UserTaskConfigModel.task_type = val;
      if (["2", "3", "6"].includes(this.UserTaskConfigModel.task_type)) {
        this.filteredResponseOption = this.taskResponseOption.filter(
          (x) => x.response_type === this.UserTaskConfigModel.task_type
        );
      }
      if (this.UserTaskConfigModel.task_type == 4 || this.UserTaskConfigModel.task_type == 6) {
        this.isReaction = false;
        this.UserTaskConfigModel.reactions = [];
        this.watch_task_reaction = [];
      }
    },
    watch_task_rules(val) {
      this.handleCheckFilterTaskRule(val)
      let mappedOption = val.map((x) => x.id);
      this.UserTaskConfigModel.rules = mappedOption;
    },
    watch_task_reaction(val) {
      let mappedOption = val.map((x) => x.id);
      this.UserTaskConfigModel.reactions = mappedOption;
    },
    watch_task_response(val) {
      let mappedOption = val.map((x) => x.id);
      this.UserTaskConfigModel.responses = mappedOption;
    },
    isReaction(val) {
      if (!this.isEdit) {
        this.UserTaskConfigModel.reactions = [];
        this.UserTaskConfigModel.rules = [];
        this.watch_task_reaction = [];
        this.watch_task_rules = [];
      }
      if (!this.isReaction) {
        this.UserTaskConfigModel.reactions = [];
        this.watch_task_reaction = [];
      }
      if (val) {
        this.filteredRulesOption = this.taskRulesOption;
      } else {
        this.filteredRulesOption = this.taskRulesOption.filter((f) => f.reason === "2");
      }
    },
    watch_brand_code() {
      this.UserTaskConfigModel.brand_code = this.watch_brand_code;
      this.onResetFormBrandCode()
      this.onRefreshData();
    },
  },
  computed: {
    disableButtonSubmit() {
      let isDisabled = true;
      if (
        this.UserTaskConfigModel.brand_code &&
        this.UserTaskConfigModel.category_name &&
        this.UserTaskConfigModel.rules.length > 0 &&
        this.UserTaskConfigModel.task_type &&
        this.UserTaskConfigModel.task_name &&
        this.UserTaskConfigModel.start_date &&
        this.UserTaskConfigModel.end_date &&
        this.UserTaskConfigModel.win_limit
      ) {
        isDisabled = false;
        if (["2", "3", "6"].includes(this.UserTaskConfigModel.task_type)) {
          isDisabled = this.UserTaskConfigModel.responses.length === 0
        }
      }
      return isDisabled;
    },
  },
};
</script>

<style scoped>
.img-thumbnail {
  width: 25%;
}
.required::after {
  content: " *";
  color: red;
  font-weight: bold;
}
</style>